import { render } from "./AddDetentionAdultForm.vue?vue&type=template&id=dfdccdbe"
import script from "./AddDetentionAdultForm.vue?vue&type=script&lang=js"
export * from "./AddDetentionAdultForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__